import type {
    OlCourseArgs,
    OlCourseResultScoreType,
    OlCourseCertificateType,
} from '@modules/types/graphql';

export type UpdateCourseFormValues = Partial<{
    name: string;
    questionsCount: number;
    duration: number;
    sort: number;
    showResultScore?: OlCourseResultScoreType;
    certificateType?: OlCourseCertificateType;
}>;

class UpdateCourseRequest {
    name: OlCourseArgs['name'];
    test: OlCourseArgs['test'];
    sort: OlCourseArgs['sort'];
    certificateType: OlCourseArgs['certificateType'];

    constructor(values: UpdateCourseFormValues) {
        if (values.name) {
            this.name = values.name;
        }

        if (
            typeof values.questionsCount !== 'undefined' &&
            typeof values.duration !== 'undefined'
        ) {
            this.test = {
                questionsCount: values.questionsCount,
                duration: values.duration,
                showResultScore: values.showResultScore,
            };
        }

        if (values.sort) {
            this.sort = values.sort;
        }

        if (values.certificateType) {
            this.certificateType = values.certificateType;
        }
    }
}

export { UpdateCourseRequest };
